<script setup lang="ts">
interface ComponentProps {
  rowClass?: (row: any) => string;
  columns: any;
  data: any;
}

const {columns = [], data = [], rowClass} = defineProps<ComponentProps>();

const {t} = useI18n({
  useScope: 'global'
})
const getRowClass = (row: any) => {
  const callback = unref(rowClass)
  if (callback) {
    return callback(row)
  }
  return ''
}
</script>

<template>
  <div class="car-invoice-v2__invoice-table">
    <div class="invoice-table">
      <div class="invoice-table__header">
        <img src="~/assets/img/invoice-gradient.png">
        <template
          v-for="column in columns"
          :key="column.value"
        >
          <slot :name="`column:${column.value}`">
            <div
              class="invoice-table__column"
              :class="column.value"
              :style="{ width: column.width }"
            >
              {{ column.label }}
            </div>
          </slot>
        </template>
      </div>
      <div class="invoice-table__body">
        <div
          v-for="item in data"
          :key="item.id"
          class="invoice-table__merged-row"
          :class="[getRowClass(item)]"
        >
          <div
            class="invoice-table__row"
          >
            <template
              v-for="column in columns"
              :key="column.value"
            >
              <div
                class="invoice-table__column"
                :class="column.value"
                :style="{ width: column.width }"
              >
                <slot
                  :name="`cell:${column.value}`"
                  :row="item"
                >
                  {{ item[column.value] }}
                </slot>
              </div>
            </template>
          </div>
          <div
            class="invoice-table__row"
          >
            <div
              class="invoice-table__column"
            >
              <slot
                :name="`after-row`"
                :item="item"
              />
            </div>
          </div>
        </div>
      </div>
      <slot name="footer" />
    </div>
  </div>
</template>

<style lang="scss" scoped>

.invoice-table__merged-row{
  padding: 8px 0;
  //border-bottom: 1px solid red;
}
.invoice-table__merged-row:nth-child(2n){

  background: rgba(45, 45, 134, 0.1);
}

.car-invoice-v2__invoice-table {
  .invoice-table {
    margin-bottom: 15px;

    &__header {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 48px;
      padding: 2px 5px 0;
      color: #fff;
      font-weight: 700;

      img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: -1;
      }
    }

    &__body {
      position: relative;
      padding: 15px 0 13px;
      width: 100%;
      font-weight: 700;

      &::after {
        position: absolute;
        content: "";
        right: 0;
        top: 0;
        bottom: -87px;
        width: 11%;
        background: rgba(45, 45, 134, 0.1);
      }

      .invoice-table__body {
        word-break: break-all;
      }
    }

    &__row {
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 10px;
      padding: 0 5px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__column {
      position: relative;
      z-index: 1;
      padding: 0;
      font-size: 8px;
      padding: 0 5px;

      &.date {
        width: 11%;
        padding-left: 0;
      }

      &.year {
        width: 10%;
      }

      &.vin {
        width: 17%;
      }

      &.price {
        width: 10%;
      }

      &.container-id {
        flex: 1;
      }

      &.domestic-fee {
        width: 10%;
      }

      &.cutting-fee {
        width: 10%;
      }

      &.transportation-fee {
        width: 10%;
      }

      &.total {
        width: 10%;
        text-align: right;
        padding-right: 0;
      }
    }

    &__footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 7px 10px;
      font-weight: 700;
      border: 1px solid rgba(45, 45, 134, 0.2);
      border-left: none;
      border-right: none;

      .total {
        width: 19.6%;
      }
    }
  }
}
</style>
